import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface SalesRepsEventEntityParams {
  service: string;
  component: string;
  ids?: number[];
  id?: number;
}
export class SalesRepsEventEntity extends BaseEntityClass {
  service: string;
  component: string;
  ids?: number[];
  id?: number;
  constructor(params: SalesRepsEventEntityParams) {
    super();
    this.type = "Settings";
    this.entity_version = 2;
    this.service = params.service;
    this.component = params.component;
    this.ids = params.ids;
  }
}
